import { Injectable, NgZone } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { map } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { v4 as uuidv4 } from 'uuid';
import { $b } from '../../../libs/browser_utils.js';
import { omit } from 'lodash-es';
import { take } from 'rxjs/operators';
import { AppdataService } from '../app-data/appdata.service';
import { CommunicationInterfaceService } from '../communicationInterface/communication-interface.service';
declare var uiLoggerSdk: any;

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  /**
   * Websocket subject
   */
  socket$: WebSocketSubject<any>;
  interactionID: any;
  command = {};
  private appConfig: any;
  tmacEventsDataSource: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  tmacEventsObservable: Observable<any> = this.tmacEventsDataSource.asObservable();
  socketURL: any;
  appLabels: any;

  constructor(private route: Router, private appDataService: AppdataService, public zone: NgZone, private activatedRoute: ActivatedRoute, private commInterface: CommunicationInterfaceService) {
    console.log('%c WebsocketService', 'color:white; background: blue;');
    this.appLabels = this.appDataService.getLabels();
  }

  initalizeWebsocket = (config: any) => {
    this.appConfig = config;
    this.socket$ = webSocket({
      url: this.appConfig.websocket.wsURL,
      deserializer: (msg) => msg.data
    });

    // register to post message to received TMAC events
    this.recieveTMACEvents();
  };

  sendMessage(msg: any) {
    this.socket$.next(msg);
  }

  startWebSocket = async () => {
    let queryParams = await this.activatedRoute.queryParams.pipe(take(1)).toPromise();
    const chatmode = this.appConfig?.channelConfiguration?.chatmode;
    const channelName = this.appLabels?.liveChatComponent?.ChannelLabels[chatmode];
    let defaultStart = {
      pChannel: channelName,
      pIntent: queryParams.intent ?? '',
      pChatBotSid: uuidv4(),
      pUcid: queryParams.ucid ?? '',
      pUserId: queryParams.userID ?? '',
      visualivr: '1'
    };
    const paramData = omit({ ...queryParams }, ['intent', 'ucid']);
    const startData = {...defaultStart, ...paramData};
    this.command = {
      Command: 'start',
      Data: JSON.stringify(startData),
      InteractionId: undefined,
      routepath: this.appConfig.routepath
    };
    console.log('StartWebSocket: ', this.command);
    this.sendMessage(this.command);
    this.command = '{}';
  }

  flowMessage(data: any, InteractionId: string) {
    if (!InteractionId) {
      InteractionId = $b.GetSessionStorage('websocketInteractionID');
    }
    this.command = {
      Command: 'message',
      Data: JSON.stringify(data),
      InteractionId
    };
    console.log('Flow Message: ', this.command);
    this.sendMessage(this.command);
    this.command = '{}';
  }

  endWebSocket(InteractionId: string) {
    this.command = {
      Command: 'end',
      Data: '',
      InteractionId
    };
    console.log('End: ', this.command);
    this.sendMessage(this.command);
    this.socket$.complete();
    this.command = {};
  }

  afterRemoteInteractionEnds = () => {
    let currentQueryParams = Array.from(new URLSearchParams(window.location.search).keys()).reduce(
      (acc, val) => ({ ...acc, [val]: new URLSearchParams(window.location.search).get(val) }),
      {}
    );
    currentQueryParams = Object.fromEntries(Object.entries(currentQueryParams).sort());
    const navigationExtras: NavigationExtras = {
      queryParamsHandling: 'preserve',
      preserveFragment: true,
      queryParams: currentQueryParams,
      state: { reload: true }
    };

    // [MS: Sep 13, '21] route to custom static page if configured
    if (this.appConfig?.Miscellaneous?.CustomStartPageUrl) {
      location.href = this.appConfig?.Miscellaneous?.CustomStartPageUrl + location.search;
    } else if (this.appConfig?.Miscellaneous?.ThankyoupageEnabled) {
      this.zone.run(() => { 
        this.route.navigate(['/thank-you'], navigationExtras);
      });
    } else {
      this.zone.run(() => { 
        this.route.navigate(['/'], navigationExtras);
      });
    }
  };

  recieveTMACEvents = () => {
    const TMACEvents = [];
    localStorage.setItem('TMACEvents', JSON.stringify(TMACEvents));
    window.addEventListener('message', (res) => {
      try {
        let updatedValue: any[];
        let valueUpdated = false;
        // return if not the message from TMAC
        if (!res.data.function || res.data.function !== 'onTMACEvent') {
          return;
        }
        // process the data
        res.data.data.forEach((x: { EventName: any }) => {
          let currentValue = this.tmacEventsDataSource.getValue();
          currentValue = map(currentValue, (item: { EventName: any }) => {
            if (item.EventName === x.EventName) {
              item = x;
              valueUpdated = true;
            }
            return item;
          });

          if (!valueUpdated) {
            updatedValue = [...currentValue, x];
          } else {
            updatedValue = currentValue;
          }

          console.debug('TMAC events received', updatedValue.map((t) => t.EventName).join(','));
          this.commInterface.sendUIDebug('WebsocketService', "recieveTMACEvents", 'TMAC events received', updatedValue.map((t) => t.EventName).join(','));
          this.tmacEventsDataSource.next(updatedValue);
        });
      } catch (e) {
        console.error(e);
        this.commInterface.sendUIErrors('WebsocketService', "recieveTMACEvents", e);
          
      }
    });

    // to make sure the latest event are reached, make a post message to AD for events
    const element = parent ?? opener;
    // send post message to the element
    element?.postMessage(
      {
        function: 'getTMACEvents',
        name: window.name,
        callback: null,
        data: null,
        source: 'vivr',
        destination: 'tmac',
        userObject: null
      },
      '*'
    );
    console.log('Sending post message to AD to get TMAC events');
  };
}
